import TgCertMgrCtrlClass from '@/utils/king-grid-util/tg-cert-mgr-ctrl'

const state = {
  TGCertPlugin: null
}

const actions = {
  /**
   * 初始化金格服务
   * @param state
   * @returns {Promise<unknown>}
   */
  getKingGridService({ state }) {
    return new Promise((resolve, reject) => {
      if (state.TGCertPlugIn) {
        return resolve(state.TGCertPlugIn)
      }
      state.TGCertPlugIn = new TgCertMgrCtrlClass()
      state.TGCertPlugIn.kg
        .init()
        .then(() => {
          resolve(state.TGCertPlugIn)
        })
        .catch(err => {
          state.TGCertPlugIn = null
          reject(err)
        })
    })
  },

  /**
   * 在线签章登出
   */
  kingGridLogout({ dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch('getKingGridService')
        .then(TGCertPlugIn => {
          TGCertPlugIn.TG_InitCAPlugin(
            JSON.stringify({
              providerName: '招签宝',
              CAType: '1',
              initInfo: '',
              appId: '',
              loginInfo: ''
            })
          )
            .then(() => {
              resolve(TGCertPlugIn)
            })
            .catch(() => {
              resolve(TGCertPlugIn)
            })
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * 获取CA证书列表
   * @param CAType {Number} CATypeDict的字典值
   * @returns {Promise<never>|Promise<unknown>}
   */
  getCAList({ dispatch }, CAType) {
    return new Promise((resolve, reject) => {
      const certList = []

      dispatch('getKingGridService')
        .then(TGCertPlugIn => {
          TGCertPlugIn.TG_GetCAProviderList(JSON.stringify({ CAType: CAType }))
            .then(async providerResult => {
              if (providerResult.errorCode !== 0) {
                reject({ message: '获取CA提供商列表失败' })
                return
              }

              // eslint-disable-next-line no-unused-vars
              for (const value of providerResult.CAProviderList) {
                try {
                  const partialCertList = await TGCertPlugIn.TG_GetCertList(
                    JSON.stringify({
                      providerName: value.providerName,
                      CAType: value.CAType,
                      filterCondition: JSON.stringify({
                        publisher: 'ZJCA;CFCA;ZHCA',
                        isCheckValid: 0
                      })
                    })
                  )

                  if (partialCertList.errorCode === 0) {
                    certList.push(...partialCertList.certData)
                  }
                } catch (e) {
                  // console.log('???', e)
                }
              }

              resolve(certList)
            })
            .catch(err => {
              reject(err)
            })
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * 实体CA解密-调用CA中间件解密数字信封
   */
  decryptData({ state, dispatch }, digitalEnvelope) {
    return new Promise((resolve, reject) => {
      dispatch('getKingGridService')
        .then(TGCertPlugIn => {
          TGCertPlugIn.TG_DecryptData(digitalEnvelope)
            .then(res => {
              const { errorCode } = res
              if (errorCode === 0) {
                resolve(res.receiverInfo.outDataB64)
              } else {
                reject(res)
                return
              }
            })
            .catch(err => {
              console.log('TG_DecryptData err: ', err)
              reject(err)
            })
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  actions
}
